export default "__VITE_ASSET__DsUciLLj__"